import { useTranslation } from 'react-i18next';

import '../../styles/Contact.css';
import Header from '../../components/layout/Header';
import { trackMatomoEvent } from '../../utils/matomo';

const ContactSection = () => {
  const { t } = useTranslation();
  const phone = '41718411216';
  const bookingHref =
    'https://outlook.office.com/book/BlueAlps@bluealps.org/?ismsaljsauthenabled';
  const href = `https://api.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
    t('contact.messages.general'),
  )}`;

  return (
    <main className="contact-page">
      <Header />
      <section className="contact-linktree">
        <div className="contact-card">
          <h1 className="contact-card__title">{t('contact.title')}</h1>
          <p className="contact-card__subtitle">{t('contact.subtitle')}</p>
          <p className="contact-card__highlight">
            {t('contact.direct_contact_note')}
          </p>
          <div className="contact-links">
            <a
              className="contact-link"
              href={href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackMatomoEvent('Contact', 'click', 'WhatsApp contact')
              }
            >
              <span className="contact-link__icon" aria-hidden>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                >
                  <path d="M20.52 3.48A11.86 11.86 0 0 0 12.03 0C5.46 0 .12 5.34.12 11.91a11.84 11.84 0 0 0 1.62 5.96L0 24l6.31-1.65a11.88 11.88 0 0 0 5.72 1.46h.01c6.56 0 11.9-5.34 11.9-11.91a11.8 11.8 0 0 0-3.42-8.42Zm-8.49 18.4h-.01a9.92 9.92 0 0 1-5.07-1.39l-.36-.22-3.75.98 1-3.65-.24-.37A9.9 9.9 0 1 1 21.9 11.9a9.9 9.9 0 0 1-9.87 9.98Zm5.44-7.45c-.3-.15-1.77-.87-2.05-.97s-.48-.15-.69.15-.79.97-.97 1.17-.36.22-.66.07a8.19 8.19 0 0 1-2.4-1.49 9.07 9.07 0 0 1-1.67-2.08c-.18-.3 0-.46.14-.61.14-.14.3-.36.45-.54a2.1 2.1 0 0 0 .3-.5.56.56 0 0 0-.03-.53c-.07-.15-.69-1.65-.95-2.26-.25-.6-.51-.52-.69-.53h-.59a1.13 1.13 0 0 0-.81.38 3.41 3.41 0 0 0-1.07 2.54 5.95 5.95 0 0 0 1.24 3.14 13.44 13.44 0 0 0 5.12 4.03c.64.28 1.15.45 1.54.58.64.2 1.23.17 1.7.1.52-.08 1.77-.72 2.02-1.41s.25-1.28.17-1.41-.28-.2-.58-.35Z" />
                </svg>
              </span>
              <span className="contact-link__text">
                <strong>{t('contact.whatsapp_label')}</strong>
                <span>{t('contact.roles.support')}</span>
              </span>
              <span className="contact-link__cta">{t('contact.cta')}</span>
            </a>

            <a
              className="contact-link contact-link--email"
              href="mailto:contact@bluealps.org"
              onClick={() =>
                trackMatomoEvent('Contact', 'click', 'Email contact')
              }
            >
              <span className="contact-link__icon" aria-hidden>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M4 6H20C20.55 6 21 6.45 21 7V17C21 17.55 20.55 18 20 18H4C3.45 18 3 17.55 3 17V7C3 6.45 3.45 6 4 6Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M3 7L12 13L21 7"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>

              <span className="contact-link__text">
                <strong>{t('contact.email_label')}</strong>
                <span>contact@bluealps.org</span>
              </span>

              <span className="contact-link__cta">
                {t('contact.cta_email')}
              </span>
            </a>

            <a
              className="contact-link contact-link--booking"
              href={bookingHref}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() =>
                trackMatomoEvent('Contact', 'click', 'Booking contact')
              }
            >
              <span className="contact-link__icon" aria-hidden>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M7 3V6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M17 3V6"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M4 8H20"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M5 5H19C20.1 5 21 5.9 21 7V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V7C3 5.9 3.9 5 5 5Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M9 14L11 16L15.5 11.5"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>

              <span className="contact-link__text">
                <strong>{t('contact.booking_label')}</strong>
                <span>{t('contact.booking_hint')}</span>
              </span>

              <span className="contact-link__cta">
                {t('contact.cta_booking')}
              </span>
            </a>
          </div>
        </div>
      </section>
    </main>
  );
};

export default ContactSection;
